import './App.css'

import { BrowserRouter, useRoutes } from 'react-router-dom'

import Home from './Home'
import Cookies from './policy/cookies'
import Privacy from './policy/privacy'
import Terms from './policy/terms'
import Contact from './Contact'

import {
  useReducer,
} from 'react'

import {
  Context,
  initialState,
} from './store/Context'

import {
  reducer,
} from './store/reducer'

function RouteElements() {
  const routeElements = useRoutes([
    { path: '/', element: <Home /> },
    { path: '/privacy', element: <Privacy /> },
    { path: '/policy/cookies', element: <Cookies /> },
    { path: '/policy/privacy', element: <Privacy /> },
    { path: '/policy/terms', element: <Terms /> },
    { path: '/contact', element: <Contact /> },
  ]);
  return routeElements
}

function App() {
  const [state, dispatch] = useReducer(reducer, initialState)
  const value = { state, dispatch }

  return (
    <Context.Provider value={value}>
      <BrowserRouter>
        <RouteElements />
      </BrowserRouter>
    </Context.Provider>
  )
}

export default App
